import { useEffect } from 'react';

function TimerComponent() {
    useEffect(() => {
        const timerID = setInterval(() => {
            console.log('Timer tick');
        }, 1000);

        return () => {
            clearInterval(timerID);
        };
    }, []); // Empty dependency array means this runs only on mount
}

export default TimerComponent